import React from "react";

export function Footer() {
  return (
    <footer className="mx-auto w-full max-w-[40rem] px-6 pb-10">
      <div className="flex items-center justify-between gap-4 border-t border-border pt-6 text-[13px] text-lightgray">
        <span>Krushil Amrutiya</span>
        <a
          href="mailto:connect@krushil.com"
          className="hover:text-darkgray transition-colors"
        >
          connect@krushil.com
        </a>
      </div>
    </footer>
  );
}
